var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTerrible = function SvgTerrible(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "currentColor",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5245_18122)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 21,
    r: 16,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 21,
    r: 16,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 21,
    r: 15,
    stroke: "#D67504",
    strokeOpacity: 0.27,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4839 29.6145C31.7686 26.0387 32.5393 21.7016 31.6263 17.5575C30.7133 13.4135 28.1915 9.80177 24.6157 7.51702C21.0398 5.23226 16.7028 4.4616 12.5587 5.37456C8.41458 6.28752 4.8029 8.80932 2.51814 12.3852L16.001 20.9999L29.4839 29.6145Z",
    fill: "url(#paint2_radial_5245_18122)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_5245_18122)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.74607 27.0133C9.50276 25.719 10.7199 24.7577 12.1543 24.3215L13.0087 24.0617C15.2848 23.3695 17.7152 23.3695 19.9913 24.0617L20.8457 24.3215C22.2801 24.7577 23.4972 25.719 24.2539 27.0133V27.0133C25.0275 28.3366 24.0731 30 22.5404 30H10.4596C8.92685 30 7.97248 28.3366 8.74607 27.0133V27.0133Z",
    fill: "#DD573A"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_5245_18122)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-5-outside-1_5245_18122",
    maskUnits: "userSpaceOnUse",
    x: 22.8159,
    y: 0.644458,
    width: 9.32473,
    height: 15.0028,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 22.8159,
    y: 0.644458,
    width: 9.32473,
    height: 15.0028
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.9974 2.49751L27.043 1.97656L26.566 9.00045L28.0432 9.26093L29.9974 2.49751ZM26.4791 14.0623C27.2949 14.2061 28.0729 13.6614 28.2168 12.8455C28.3606 12.0297 27.8159 11.2517 27 11.1078C26.1842 10.964 25.4062 11.5087 25.2624 12.3246C25.1185 13.1404 25.6633 13.9184 26.4791 14.0623Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.9974 2.49751L27.043 1.97656L26.566 9.00045L28.0432 9.26093L29.9974 2.49751ZM26.4791 14.0623C27.2949 14.2061 28.0729 13.6614 28.2168 12.8455C28.3606 12.0297 27.8159 11.2517 27 11.1078C26.1842 10.964 25.4062 11.5087 25.2624 12.3246C25.1185 13.1404 25.6633 13.9184 26.4791 14.0623Z",
    fill: "#FF453A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.043 1.97656L27.2166 0.991755L26.1207 0.798508L26.0453 1.90882L27.043 1.97656ZM29.9974 2.49751L30.9581 2.77508L31.267 1.70595L30.171 1.5127L29.9974 2.49751ZM26.566 9.00045L25.5683 8.93271L25.5075 9.82922L26.3924 9.98526L26.566 9.00045ZM28.0432 9.26093L27.8696 10.2457L28.7545 10.4018L29.004 9.5385L28.0432 9.26093ZM26.8693 2.96137L29.8237 3.48231L30.171 1.5127L27.2166 0.991755L26.8693 2.96137ZM27.5637 9.0682L28.0407 2.04431L26.0453 1.90882L25.5683 8.93271L27.5637 9.0682ZM28.2169 8.27612L26.7397 8.01565L26.3924 9.98526L27.8696 10.2457L28.2169 8.27612ZM29.0367 2.21993L27.0825 8.98335L29.004 9.5385L30.9581 2.77508L29.0367 2.21993ZM27.232 12.6719C27.184 12.9438 26.9247 13.1254 26.6527 13.0774L26.3054 15.0471C27.6652 15.2868 28.9618 14.3789 29.2016 13.0192L27.232 12.6719ZM26.8264 12.0926C27.0983 12.1406 27.2799 12.3999 27.232 12.6719L29.2016 13.0192C29.4413 11.6594 28.5334 10.3628 27.1737 10.123L26.8264 12.0926ZM26.2472 12.4982C26.2951 12.2263 26.5544 12.0447 26.8264 12.0926L27.1737 10.123C25.814 9.88327 24.5173 10.7912 24.2775 12.1509L26.2472 12.4982ZM26.6527 13.0774C26.3808 13.0295 26.1992 12.7702 26.2472 12.4982L24.2775 12.1509C24.0378 13.5107 24.9457 14.8073 26.3054 15.0471L26.6527 13.0774Z",
    fill: "white",
    fillOpacity: 0.8,
    mask: "url(#path-5-outside-1_5245_18122)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_5245_18122)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-7-outside-2_5245_18122",
    maskUnits: "userSpaceOnUse",
    x: 27.7417,
    y: 1.51165,
    width: 9.32473,
    height: 15.0028,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 27.7417,
    y: 1.51165,
    width: 9.32473,
    height: 15.0028
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.9232 3.36469L31.9688 2.84375L31.4918 9.86764L32.969 10.1281L34.9232 3.36469ZM31.4049 14.9294C32.2207 15.0733 32.9987 14.5285 33.1426 13.7127C33.2864 12.8969 32.7417 12.1189 31.9258 11.975C31.11 11.8312 30.332 12.3759 30.1881 13.1918C30.0443 14.0076 30.589 14.7856 31.4049 14.9294Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.9232 3.36469L31.9688 2.84375L31.4918 9.86764L32.969 10.1281L34.9232 3.36469ZM31.4049 14.9294C32.2207 15.0733 32.9987 14.5285 33.1426 13.7127C33.2864 12.8969 32.7417 12.1189 31.9258 11.975C31.11 11.8312 30.332 12.3759 30.1881 13.1918C30.0443 14.0076 30.589 14.7856 31.4049 14.9294Z",
    fill: "#FF453A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9688 2.84375L32.1424 1.85894L31.0464 1.6657L30.971 2.776L31.9688 2.84375ZM34.9232 3.36469L35.8839 3.64227L36.1928 2.57313L35.0968 2.37989L34.9232 3.36469ZM31.4918 9.86764L30.4941 9.79989L30.4332 10.6964L31.3182 10.8524L31.4918 9.86764ZM32.969 10.1281L32.7954 11.1129L33.6803 11.269L33.9297 10.4057L32.969 10.1281ZM31.7951 3.82856L34.7495 4.3495L35.0968 2.37989L32.1424 1.85894L31.7951 3.82856ZM32.4895 9.93539L32.9665 2.9115L30.971 2.776L30.4941 9.79989L32.4895 9.93539ZM33.1427 9.1433L31.6655 8.88283L31.3182 10.8524L32.7954 11.1129L33.1427 9.1433ZM33.9625 3.08712L32.0083 9.85054L33.9297 10.4057L35.8839 3.64227L33.9625 3.08712ZM32.1578 13.5391C32.1098 13.811 31.8505 13.9926 31.5785 13.9446L31.2312 15.9143C32.591 16.154 33.8876 15.2461 34.1274 13.8864L32.1578 13.5391ZM31.7522 12.9598C32.0241 13.0078 32.2057 13.2671 32.1578 13.5391L34.1274 13.8864C34.3671 12.5266 33.4592 11.23 32.0995 10.9902L31.7522 12.9598ZM31.1729 13.3654C31.2209 13.0935 31.4802 12.9119 31.7522 12.9598L32.0995 10.9902C30.7397 10.7505 29.4431 11.6584 29.2033 13.0181L31.1729 13.3654ZM31.5785 13.9446C31.3066 13.8967 31.125 13.6374 31.1729 13.3654L29.2033 13.0181C28.9636 14.3778 29.8715 15.6745 31.2312 15.9143L31.5785 13.9446Z",
    fill: "white",
    fillOpacity: 0.8,
    mask: "url(#path-7-outside-2_5245_18122)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter3_di_5245_18122)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.6172 12.1211V12.1211C21.4737 12.6866 22.4905 12.959 23.515 12.8976V12.8976",
    stroke: "#823423",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter4_di_5245_18122)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.48828 12.8984V12.8984C9.51277 12.9599 10.5296 12.6875 11.3861 12.122V12.122",
    stroke: "#823423",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_5245_18122)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 15,
    width: 6,
    height: 6,
    rx: 3,
    fill: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 18,
    r: 1.5,
    fill: "#772F20"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_5245_18122)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 15,
    width: 6,
    height: 6,
    rx: 3,
    fill: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 18,
    r: 1.5,
    fill: "#772F20"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_5245_18122",
    x: 7.47266,
    y: 23.543,
    width: 18.0547,
    height: 8.45703,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5245_18122"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5245_18122",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_5245_18122"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_5245_18122",
    x: 22.2383,
    y: -0.203125,
    width: 11.0273,
    height: 18.2891,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.270588 0 0 0 0 0.227451 0 0 0 0.21 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5245_18122"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5245_18122",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_5245_18122",
    x: 27.1641,
    y: 0.664062,
    width: 11.0273,
    height: 18.2891,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.270588 0 0 0 0 0.227451 0 0 0 0.21 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5245_18122"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5245_18122",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_di_5245_18122",
    x: 18.6172,
    y: 11.1211,
    width: 6.89844,
    height: 4.78516,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5245_18122"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5245_18122",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_5245_18122"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_di_5245_18122",
    x: 6.48828,
    y: 11.1211,
    width: 6.89844,
    height: 4.78516,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5245_18122"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5245_18122",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_5245_18122"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_5245_18122",
    x: 17,
    y: 13,
    width: 10,
    height: 10,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.570833 0 0 0 0 0.292552 0 0 0 0 0.0356771 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5245_18122"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5245_18122",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_5245_18122",
    x: 5,
    y: 13,
    width: 10,
    height: 10,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.570833 0 0 0 0 0.292552 0 0 0 0 0.0356771 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5245_18122"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5245_18122",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_5245_18122",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16 5) rotate(90) scale(32)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EED919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1BE08"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5245_18122",
    x1: 16,
    y1: 5,
    x2: 16,
    y2: 37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.52
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_5245_18122",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.501 11.4999) rotate(132.138) scale(14.1598)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA360B",
    stopOpacity: 0.71
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9A709",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5245_18122"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    fill: "white"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTerrible, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/terrible.3d8110c1.svg";
export { ForwardRef as ReactComponent };